import { DataGrid, gridClasses, GridToolbar, GridColDef } from "@mui/x-data-grid";
import { alpha } from "@mui/material/styles";
import { styled } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import NoDataOverlay from "pages/Survey/components/NoDataOverlay";

type TableProps = {
  dataGridColumns: GridColDef[];
  rows?: any;
  isLoading?: boolean;
  fileName: string;
};

const Table = ({ dataGridColumns, rows, isLoading, fileName }: TableProps) => {
  return (
    <div style={{ height: 615, width: "100%" }}>
      <StripedDataGrid
        columns={dataGridColumns || []}
        loading={isLoading}
        rows={rows || []}
        components={{
          Toolbar: GridToolbar,
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: NoDataOverlay,
        }}
        componentsProps={{
          toolbar: {
            csvOptions: {
              disableToolbarButton: false,
              fileName: fileName || "archivo",
            },
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 250 },
          },
        }}
        getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd")}
      />
    </div>
  );
};

export default Table;

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  ".css-1rcsupe-MuiButtonBase-root-MuiCheckbox-root": {
    color: `${theme.palette.text.primary} !important`,
  },
  "&.MuiDataGrid-root": {
    height: "90%",
    "@media (max-width: 570px)": {
      height: "60%",
    },
    "@media screen and (min-width: 570px) and (max-width:900px)": {
      height: "70%",
    },
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: "#e9ebec",
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&.Mui-selected": {
      "&:hover, &.Mui-hovered": {
        "@media (hover: none)": {},
      },
    },
  },
}));
